(function () {
  if (!['destructive-staging.myshopify.com', 'dsrcv.com', 'www.dsrcv.com', 'dsrcv.myshopify.com'].includes(location.hostname)) return;
  var themeId = location.hostname === 'destructive-staging.myshopify.com' ? '208998072645' : '187352842618';
  var escapeSummary = null;
  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !event.target.closest) return;
    var details = event.target.closest('[data-bf-basket-delivery][data-theme-id="' + themeId + '"]');
    if (!details || !details.open) return;
    event.preventDefault();
    event.stopPropagation();
    details.open = false;
    escapeSummary = details.querySelector('summary');
    escapeSummary.focus();
  }, true);
  window.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' || !escapeSummary) return;
    if (event.target === escapeSummary) {
      event.preventDefault();
      event.stopPropagation();
    }
    escapeSummary = null;
  }, true);
}());
